import { ThemeProvider, useMediaQuery } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import MobileUnavailableScreen from "./Components/UI/MobileUnavailableScreen";
import SnackbarAlert from "./Components/Snackbar/SnackbarAlert";
import "./index.css";
import { store, persistor } from "./redux-toolkit/store";
import { installRequestIdFetchInterceptor } from "./utils/requestId";
import { isMobileTakeActionFlow } from "./utils/mobileAppGate";

const theme = createTheme({
  typography: {
    fontFamily: ["Montserrat, sans-serif"].join(","),
  },
  palette: {
    primary: {
      main: "#3361cf",
    },
    success: {
      main: "#2CAB35",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      xxl: 2550,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

installRequestIdFetchInterceptor();

const RootRoute = () => {
  const location = useLocation();
  const isMobileViewport = useMediaQuery("(max-width:768px)");
  const isTouchDevice =
    typeof window !== "undefined" &&
    window.matchMedia("(pointer: coarse)").matches;
  const isMobileTouchDevice = isMobileViewport && isTouchDevice;
  const allowTakeAction = isMobileTakeActionFlow(location.pathname);

  return (
    <>
      {isMobileTouchDevice && !allowTakeAction ? (
        <MobileUnavailableScreen />
      ) : (
        <App />
      )}
      <SnackbarAlert />
    </>
  );
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <PersistGate loading={null} persistor={persistor}>
            <Routes>
              <Route path="/*" element={<RootRoute />} />
            </Routes>
          </PersistGate>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);
